import colors from "./styleColors"

export const common = {
  fontFamily: "Open Sans, sans-serif",
  xsFontSize: 8,
  sFontSize: 10,
  mFontSize: 12,
  lFontSize: 16
}

/**
 * See: https://api.highcharts.com/class-reference/Highcharts.CSSObject
 * @type {*}
 */
const commonCSSStyle = {
  color: colors.textColor,
  fontFamily: common.fontFamily,
  textOutline: "none",
  textOverflow: "none"
}

const iPhone5CSSStyle = {
  ...commonCSSStyle,
  fontSize: common.xsFontSize
}

const iPhone8CSSStyle = {
  ...commonCSSStyle,
  fontSize: common.sFontSize
}

const smBreakpointsCSSStyle = {
  ...commonCSSStyle,
  fontSize: common.sFontSize
}

const defaultCSSStyle = {
  ...commonCSSStyle,
  fontSize: common.mFontSize
}

export function responsiveCSSStyle() {
  // this is 5 iphone width
  if (window.innerWidth <= 320) {
    return iPhone5CSSStyle
  }
  if (window.innerWidth <= 375) {
    return iPhone5CSSStyle
  }

  // this is 6/7/8 iPhone width
  if (window.innerWidth <= 414) {
    return iPhone8CSSStyle
  }
  // this is Material-ui SM breakpoints
  if (window.innerWidth <= 600) {
    return smBreakpointsCSSStyle
  }
  return defaultCSSStyle
}
